module.exports = __webpack_public_path__ + "img/selected_icon.7b160638.svg";